export default {
  svgData: [
    {
      id: "slide6tv",
      name: "Avatar",
      url: "https://majormobilityga.com/projects/i75cvl/"
    },
    {
      id: "slide6display1",
      name: "Display",
      url:
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/comment/cvl-pioh-handout.pdf",
      label: "slide6display1"
    },
    {
      id: "slide6display2",
      name: "Display",
      url:
        "https://0014203-gdot.hub.arcgis.com/app/d294b6790e4b4ee082e1e91fb0b69332",
      label: "slide6display2"
    },
    {
      id: "slide6avatar1",
      name: "Avatar"
    },
    {
      id: "slide6bubble1",
      label: "slide6bubble1"
    },
    {
      id: "slide6bubble2", // placeholder for time-triggered text
      label: "slide6bubble2"
    },
    {
      id: "slide6bubble3", // placeholder for time-triggered text
      label: "slide6bubble3"
    }
  ],
  slideTitle: "Live Event/Comment Station",
  aboutText: `
    <p class="text-justify help">
    We hope that the information provided in this virtual space answered many of your questions and you 
    learned more about the I-75 Commercial Vehicle Lanes project.
    </p>
    <p class="text-justify help">
    Remember to review and submit comments on the following documents found in the space: 
    </p>
    <ul class="text-justify help">
      <li>
      <b>Project Concept Display</b> (located in the Project Design station)
      </li>
      <br>
      <li>
      <b>Proposed Detours</b> (located in the Potential Detours station)
      </li>
    </ul>
  <br>
  <p class="text-justify help">
  For additional information, we invite you to join us for a live, Virtual Presentation and Question & Answer Session 
  with the I-75 Commercial Vehicle Lanes project team on <b>December 2, 2020</b>, from <b>5:30 p.m. to 7:30 p.m.</b> 
  Visit <a href="https://majormobilityga.com/projects/i75cvl/" target="_blank"></a> on the day of the event for the link to join the online 
  Virtual Presentation and Question & Answer Session or to call in for the session. 
  </p>

    `,
  helpText: `
    <p class="text-justify help">
    Thank you for visiting our interactive I-75 Commercial Vehicle Lanes project virtual meeting room.
    </p>
    <p class="text-justify help">
    Before you leave, please be sure to review and submit comments on the following documents found in the space:
    </p>
    <ul class="text-justify help">
      <li>
      <b><u>Concept Display</b></u> (located in the Project Design station)
      </li>
      <li>
      <b><u>Proposed Detours</b></u> (located in the Potential Detours station)
      </li>
    </ul>
    <br>
    <p class="text-justify help">
    <b>Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out</b>.
    </p>
    <p class="text-justify help">
    This concludes the tour of the virtual meeting room. Feel free to navigate back to other stations in the meeting space.
    Also, please join us for the live, Virtual Presentation and Question and Answer Session on December 2, 2020, from 5:30 p.m. to 7:30 p.m.  
    `
};
